import React, { useEffect } from "react";
import "../../css/ScrollAnimations.css"; // Add animations here

export default function RoomsSection() {

  useEffect(() => {
    const elements = document.querySelectorAll(".reveal-drop");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("drop-active");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );

    elements.forEach((el) => observer.observe(el));
  }, []);

  return (
    <div className="section background-grey over-hide">
      <div className="container-fluid px-0">

        {/* Rooms Section */}
        <div className="row mx-0">
          <div className="col-xl-6 px-0">
            <div className="img-wrap reveal-drop" id="rev-1">
              <img src="/img/9.jpeg" alt="" />
              <div className="text-element-over">Our Rooms</div>
            </div>
          </div>

          <div className="col-xl-6 px-0 mt-4 mt-xl-0 align-self-center">
            <div className="row justify-content-center">
              <div className="col-10 col-xl-8 text-center">
                <h3>Our Rooms</h3>
                <p className="text-justify mt-4">
                 At Hotel Pahadi Convention, you can unwind in any of our 57 spacious and beautifully designed rooms, created to offer a peaceful and comfortable stay. Each room comes equipped with essentials like free Wi-Fi, a flat-screen TV, and air-conditioning, ensuring a pleasant experience from the moment you arrive. With a selection of room types including Deluxe Rooms and Suites, along with round-the-clock room service, we provide everything you need for a truly relaxing stay in Rourkela.
                </p>
                <a className="mt-5 btn btn-primary" href="/contact">check availability</a>
              </div>
            </div>
          </div>
        </div>

        {/* Banquet Section */}
        <div className="row mx-0">
          <div className="col-xl-6 px-0 mt-4 mt-xl-0 pb-5 pb-xl-0 align-self-center">
            <div className="row justify-content-center">
              <div className="col-10 col-xl-8 text-center">
                <h3>Banquet Hall</h3>
                <p className="text-justify mt-4">
                  Our banquet hall is one of Rourkela’s top event venues, offering a spacious and elegant setting that comfortably hosts 500+ guests. Ideal for weddings, receptions, corporate meetings, and large gatherings, the hall features modern lighting, flexible seating, and advanced audiovisual facilities. With dedicated event support and customizable décor options, we ensure every occasion is executed smoothly and leaves a lasting impression.
                </p>
                <a className="mt-5 btn btn-primary" href="/contact">check availability</a>
              </div>
            </div>
          </div>

          <div className="col-xl-6 px-0 order-first order-xl-last mt-5 mt-xl-0">
            <div className="img-wrap reveal-drop" id="rev-2">
              <img src="/img/2.jpeg" alt="" />
              <div className="text-element-over">Banquet Hall</div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}
